<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">ユニークキー配信</div>
        </div>
        <a class="c-btn c-btn--blue u-w250" href="/coins-admin/unique-key-message/add">
          <p class="c-btn__text">配信を作成</p>
        </a>
      </div>
      <div class="l-main-content">
        <div class="p-message-result">
          <form class="unique-key-messages-search" @submit.prevent="onSearch">
            <div class="c-input u-w400">
              <input
                id="uniqueKeyMessageSearchName"
                v-model="name"
                class="c-input__item"
                type="text"
                placeholder="管理用タイトルで検索"
              />
            </div>
            <select
              id="uniqueKeyMessageSearchStatus"
              v-model="status"
              class="unique-key-messages-search__status"
              @change="onSearch"
            >
              <option value="">すべての状態</option>
              <option v-for="value in statusFilters" :key="value" :value="value">{{ deliverStatusLabels[value] }}</option>
            </select>
            <button type="submit" class="c-btn c-btn--blue u-w120 u-h40">
              <p class="c-btn__text">検索</p>
            </button>
          </form>

          <div
            class="p-message-result__data"
            :class="{ 'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }"
          >
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">ユニークキー配信がありません</div>
            </div>
            <table class="c-table">
              <thead>
                <tr>
                  <th class="c-table__cell--center">管理用タイトル</th>
                  <th class="c-table__cell--center is-sortable u-w180">
                    <span class="c-table__text">配信日時</span>
                    <sort-switch name="sendStartDate" :order="order" @on-click="onSortClick" />
                  </th>
                  <th class="c-table__cell--center u-w90">状態</th>
                  <th class="c-table__cell--center u-w70">作成元</th>
                  <th class="c-table__cell--center">リスト</th>
                  <th class="c-table__cell--center u-w90">配信数</th>
                  <th class="c-table__cell--center u-w90">表示数</th>
                  <th class="c-table__cell--center u-w90">クリック数</th>
                  <th class="c-table__cell--center u-w70"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="message in messages" :key="message.message_id" class="unique-key-messages-row">
                  <td class="c-table__cell">
                    <a class="unique-key-messages-row__name" :href="detailUrl(message)">{{ message.message_name }}</a>
                  </td>
                  <td class="c-table__cell c-table__cell--center">{{ getDisplayDateTime(message.send_start_date) }}</td>
                  <td class="c-table__cell c-table__cell--center">{{ deliverStatusLabels[message.deliver_status] }}</td>
                  <td class="c-table__cell c-table__cell--center">{{ message.is_api ? 'API' : 'CMS' }}</td>
                  <td class="c-table__cell">{{ message.list_name || '-' }}</td>
                  <td class="c-table__cell c-table__cell--right">{{ formatCount(message.distribution_count) }}</td>
                  <td class="c-table__cell c-table__cell--right">{{ formatCount(message.display_count) }}</td>
                  <td class="c-table__cell c-table__cell--right">{{ formatCount(message.click_count) }}</td>
                  <td class="c-table__cell c-table__cell--center">
                    <button
                      v-if="message.is_stoppable"
                      type="button"
                      class="c-btn c-btn--gray u-w60 u-h32 u-fs--s unique-key-messages-row__stop"
                      @click="stoppingMessage = message"
                    >
                      停止
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>
        </div>
      </div>
    </main>

    <control-modal
      ref="refStopModal"
      classes="c-modal--message-puse"
      title="以下の配信を停止してもよろしいですか?"
      :body="stoppingMessage ? `配信 : ${stoppingMessage.message_name}` : ''"
      cancel-button-label="キャンセル"
      enter-button-label="停止する"
      :is-active="stoppingMessage !== null"
      :on-close-click="onCloseStopModal"
      :on-cancel-click="onCloseStopModal"
      :on-enter-click="onEnterStopModal"
    />

    <error-modal :is-active="errorMessage !== ''" :message="errorMessage" :on-close-click="onCloseErrorModal" />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    csrfToken: String,
    deliverStatusLabels: Object,
  },
  data() {
    return {
      name: '',
      status: '',
      // 配信日時の並び順. -1: 新しい順 (既定), 1: 古い順
      order: -1,
      page: 1,
      messages: [],
      paginationInfo: null,
      isLoading: false,
      isLoaded: false,
      isEmpty: false,
      stoppingMessage: null,
      errorMessage: '',
      statusFilters: ['0', '10', '20', '30', '40'],
    };
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    loadData: function () {
      this.isLoading = true;
      this.isLoaded = false;
      const params = { name: this.name, order: this.order, page: this.page };
      if (this.status !== '') {
        params.status = [this.status];
      }
      axios
        .get('/api/unique-key-message/list', { params })
        .then((res) => {
          this.messages = res.data.messages.data;
          this.paginationInfo = res.data.messages;
          this.isLoading = false;
          this.isLoaded = true;
          this.isEmpty = this.messages.length < 1;
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.isLoading = false;
          this.errorMessage = 'ユニークキー配信の取得に失敗しました。再度お試しください。';
        });
    },
    // 下書きは作成画面で続きを編集する
    detailUrl: function (message) {
      return message.deliver_status == 0
        ? '/coins-admin/unique-key-message/add?message_id=' + message.message_id
        : '/coins-admin/unique-key-message/review?message_id=' + message.message_id;
    },
    formatCount: function (value) {
      return value === null || value === undefined ? '-' : Number(value).toLocaleString();
    },
    onSearch: function () {
      this.page = 1;
      this.loadData();
    },
    onSortClick: function () {
      this.order = this.order === -1 ? 1 : -1;
      this.page = 1;
      this.loadData();
    },
    onPageClick: function (page) {
      this.page = page;
      this.loadData();
    },
    onCloseStopModal: function () {
      this.stoppingMessage = null;
      this.$refs.refStopModal.resetErrorMessage();
    },
    onEnterStopModal: function () {
      this.$refs.refStopModal.showLoader();
      axios
        .post('/api/unique-key-message/stop', { message_id: this.stoppingMessage.message_id })
        .then((res) => {
          this.$refs.refStopModal.hideLoader();
          if (!this.handleResponse(res, false)) {
            this.$refs.refStopModal.showErrorMessage(res.data.message);
            return;
          }
          this.stoppingMessage = null;
          this.loadData();
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.$refs.refStopModal.hideLoader();
          this.$refs.refStopModal.showErrorMessage('停止に失敗しました。再度お試しください。');
        });
    },
    onCloseErrorModal: function () {
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped>
.unique-key-messages-search {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}
/* 標準の矢印は枠に詰まって見えるので消し、共通の c-select と同じ三角を右に余白を取って置く (作成画面の選択欄と同じ) */
.unique-key-messages-search__status {
  height: 40px;
  padding: 0 40px 0 12px;
  border: 1px solid #d5dde4;
  border-radius: 4px;
  background: #fff
    url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20384%20320%22%3E%3Cpath%20fill%3D%22%23999999%22%20d%3D%22M384%2C0L192%2C320L0%2C0L384%2C0z%22%2F%3E%3C%2Fsvg%3E')
    no-repeat right 15px center / 12.5px auto;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
}
.unique-key-messages-row__name {
  color: #1d6fdc;
  text-decoration: underline;
  word-break: break-all;
}
td.c-table__cell--right {
  font-variant-numeric: tabular-nums;
}
</style>
